import { cachedAPIWrapper } from "../apiCaching/apiWrapper";
import { apiConfig } from "../config/apiConfig";
import { getBrandDetailsFromBrandJson } from "./share";
import { isTestEnvironment } from '../apiCaching/POST-Requests/helperModules/helperFunctions';

export function LocalizationIdentifier(): any {
    const dbaName = localStorage.getItem('dbaName');
    const countryCode = sessionStorage.getItem('countryCode');
    if (dbaName && countryCode) {
        return countryCode;
    }
    return null;
}

export function getLocalPhoneNumber(weblocationId:string): Promise<string | null>  {
    if(!weblocationId) return Promise.resolve(null);
    const request = `${apiConfig.FOOTER_BRAND_LINK}${weblocationId}`;
    return cachedAPIWrapper(request)
        .then(async (resp: any) => {
            let callTrack:any;
            resp?.callTrackings.forEach((type:any)=>{
                if(type.callTrackingTypeDescription === "WebsiteTracking"){
                    callTrack = type.callTrackingNumber;
                }
            });
            if(!callTrack){
                callTrack = resp?.mainPhoneNumber;
            }
            localStorage.setItem('localPhoneNumber', callTrack);
            return callTrack;
        })
        .catch((error) => {
            console.error('Error fetching FOOTER_BRAND_LINK:', error);
            return null;
        });
}

export async function getDisplayPhoneNumber(): Promise<string | null> {
    const localization = (document.getElementById("weblocationId") as HTMLInputElement | null) || (document.getElementById("local_weblocationId") as HTMLInputElement | null);
    let isLocalized = false;
    if (localization && Number(localization.value) > 0) {
        isLocalized = true;
    }
    let phoneNumber: string|null = await getLocalPhoneNumber(localization?.value || '');
    //If there is no phone number and if the user is not localized then fetch the phone number from the brand json
    if (!phoneNumber && !isLocalized) {
        const conceptCode = (document.getElementById('conceptCode') as HTMLInputElement)?.value;
        if (conceptCode) {
            try {
                const brandData = await getBrandDetailsFromBrandJson(conceptCode);
                if (brandData) {
                    phoneNumber = brandData.phone;
                }
                return phoneNumber;
            } catch (error) {
                console.error('Error in fetching brand details for getDisplayPhoneNumber:', error);
            }
        }
    }
    
    return phoneNumber;
}

export function isLocalized(): boolean {
    const localization = localStorage.getItem('dbaName') as HTMLInputElement | null;
    let isLocalized = false;
    if (localization) {
        isLocalized = true;
    }
    return isLocalized;
}

 //To replace the local legal and neighbourly footer in localised Header National page scenario
 
 export function replaceLegalFooter(footerHTML: string): void {
    if (!footerHTML) {
      if (isTestEnvironment()) {
        console.log('No footer HTML provided, keeping national footer');
      }
      return;
    }

    const parser = new DOMParser();
    const newFooter = parser.parseFromString(footerHTML, 'text/html');
    const existingLegalFooter = document.querySelector('.legal-footer') as HTMLElement;
    const newLegalFooter = newFooter.querySelector('.legal-footer');

    if (newLegalFooter && existingLegalFooter) {
      existingLegalFooter.innerHTML = newLegalFooter.innerHTML;
      if (isTestEnvironment()) {
        console.log('✓ Legal footer replaced with local version');
      }
    } else {
      if (isTestEnvironment()) {
        console.log('Legal footer elements not found, keeping national footer');
      }
    }
  }

  export function replaceNeighborlyFooter(footerHTML: string): void {
    if (!footerHTML) {
      if (isTestEnvironment()) {
        console.log('No footer HTML provided, keeping national neighborly footer');
      }
      return;
    }

    const parser = new DOMParser();
    const newFooter = parser.parseFromString(footerHTML, 'text/html');
    const existingSection = document.querySelector('.neighborly-ftr-section') as HTMLElement;
    const newSection = newFooter.querySelector('.neighborly-ftr-section');

    if (newSection && existingSection) {
      existingSection.innerHTML = newSection.innerHTML;
      if (isTestEnvironment()) {
        console.log('✓ Neighborly footer replaced with local version');
      }
    } else {
      if (isTestEnvironment()) {
        console.log('Neighborly footer elements not found, keeping national footer');
      }
    }
  }